<template>
  <div class="project-list padding_20">
    <div class="common-search__header">
      <div class="common-search__title">
        设备列表
      </div>
    </div>
    <Search ref="placeSearch"
            :search-array="searchArray"
            @getData="getData" />
    <commonTable :table-data="commonTableData"
                 :common-table-array="commonTableArray"
                 :is-show-operate="Boolean('true')"
                 :is-show-delete="Boolean('true')"
                 :total="total"
                 :current-page="page"
                 :page-size="size"
                 @handlePage="handlePage"
                 @handleItem="handleDetails"
                 @deleteData="deleteData" />
  </div>
</template>

<script>
import Search from '@/components/common/Search.vue';
import commonTable from '@/components/common/commonTable.vue';
import { getAllPlaces } from '@/api/place';
import { queryAll, pointDelete, pointTypes } from '@/api/devices';

export default {
  components: { Search, commonTable },
  data() {
    return {
      searchArray: [
        {
          label: '客户/项目',
          props: 'site_id',
          type: 'cascader',
        },
        {
          label: '场',
          props: 'place_id',
          type: 'select',
          list: [],
        },
        {
          label: '类型',
          props: 'solution',
          type: 'select',
          list: [],
        },
      ],
      commonTableData: [],
      commonTableArray: [
        {
          label: 'IP',
          props: 'ip',
          handle: true,
        },
        {
          label: '通道',
          props: 'ch_name',
        },
        {
          label: '楼层',
          props: 'floor_name',
        },
        {
          label: '类型',
          props: 'type',
        },
        {
          label: '型号',
          props: 'model',
        },
        {
          label: '截图',
          props: 'capture_url',
          img: true,
        },
        {
          label: '状态',
          props: 'status',
          filtersFlag: true,
        },
        {
          label: '创建时间',
          props: 'created_at',
        },
      ],
      total: 0,
      page: 1,
      size: 20,
    };
  },
  created() {
    this.getAllPlaces();
    this.getQueryAll();
    this.getPointTypes();
  },
  methods: {
    getData(data) {
      this.getQueryAll(data);
    },
    async getAllPlaces() {
      const { data } = await getAllPlaces({});
      this.searchArray[1].list = data;
    },
    async getQueryAll(data) {
      const { page, size } = this;
      await queryAll({ page, size, ...data }).then((res) => {
        this.commonTableData = res.data;
        this.total = res.data.total;
      });
    },
    handlePage(page) {
      this.page = page;
      this.getProjectAll();
    },
    deleteData(item) {
      pointDelete({ deploy_id: item.id }).then(() => {
        this.getQueryAll();
        this.$message({
          message: '删除成功',
          type: 'success',
        });
      });
    },
    handleDetails(item) {
      this.$router.push({ path: `/devicesDetails/${item.id}/${item.deploy_id}` });
    },
    getPointTypes() {
      pointTypes({}).then((res) => {
        this.searchArray[2].list = res.data.map(item => ({ id: item.props, name: item.label }));
      });
    },
  },
};
</script>
<style lang="less" scoped>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
.my-label-tasks__header {
  margin-bottom: 10px;
}
.list {
  margin: 25px 0;
  box-sizing: border-box;
  padding: 20px;
  overflow: hidden;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.place_detail {
  color: #2c2c2e;
}
</style>
